module.exports = __webpack_public_path__ + "img/favourite-icon.98be920c.svg";